module.exports = __webpack_public_path__ + "hk.bb078da1.svg";